













































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import Crumbs from "@/components/Crumbs/index.vue";
import CContentTop from "@/components/CContentTop.vue";
import End from "@/components/End/index.vue";
import { Button } from "ant-design-vue";

@Component({
  name: "NoticeDetail",
  components: {
    Crumbs,
    CContentTop,
    End,
    AButton: Button
  }
})
export default class NoticeDetail extends Base {
  private noticeId = "";
  private dataSource: any = {};
  private nearbyLoading = false;

  private created() {
    const bread: Common.CBread[] = [{ label: "通知公告", to: { name: "Notice" } }];
    this._created(bread);
    this.noticeId = (this.$route.query.noticeId as string) || "";
    this.noticeId && this.getDetail();
  }

  private async getDetail() {
    this.$message.destroy();
    const res = await this.$api.NoticeDetail(this.noticeId);
    if (res && res.code === 200) {
      this.dataSource = res.data;
    }
  }

  private get files() {
    let _return: any[] = [];

    if (this.dataSource && this.dataSource.fileInfo) {
      _return = Array.from(this.dataSource.fileInfo, (item: any) => {
        const fileName = item.fileName.split(".");

        // item.fileName = fileName[0];
        // item.fileIcon = this.$tools.getFileIcon(fileName[1]);
        // item.createTime = this.$moment(item.createTime).format("YYYY-MM-DD");
        // item.fileSize = this.$tools.bytesToSize(item.fileSize);

        item.cFileName = fileName[0];
        item.cFileIcon = this.$tools.getFileIcon(fileName[1]);
        item.cCreateTime = this.$moment(item.createTime).format("YYYY-MM-DD");
        item.cFileSize = this.$tools.bytesToSize(item.fileSize);

        return item;
      });
    }
    return _return;
  }

  /**
   * @param {number} type 0: 上一页 1: 下一页
   */
  private async getNearby(type: number) {
    this.$message.destroy();
    if (this.nearbyLoading) {
      return;
    }
    this.nearbyLoading = true;
    const res = await this.$api.NoticeNearby({
      noticeId: this.noticeId,
      turnPage: type
    });
    this.nearbyLoading = false;

    if (res && res.code === 200) {
      if (res.data) {
        this.$router.push({ name: "NoticeDetail", query: { noticeId: res.data.noticeId } });
      } else {
        this.$message.warning(type === 0 ? "已经是第一篇了" : "已经是最后一篇了");
      }
    }
  }
}
